import React, { useState } from "react";
import stilePulsanti from "../interfaccia/stilePulsanti";
import apiUrl from "../Apiurl";
import RiquadroStatoBeta from "./RiquadroStatoBeta";
import StatiTrasmessiTutti from "./StatiTrasmessiTutti";
import beep from "../../components/files/sounds/beep-6-96243.mp3";
import errorSound from "../../components/files/sounds/error-call-to-attention-129258.mp3";

function AreaLogisticaOffline(props) {
  //TODO
  //PROSSIME EVOLUTIVE:
  // MOSTRARE DATA TRASMISS. VICINO A ORDINE NEL RIQUADRO

  //const utente = props.utente
  const { buttonClassesGreen, inputClassesConTasto } = stilePulsanti;

  const [stati, setStati] = useState([
    {
      nomeRiquadro: "BRT",
      nomeStato: "PRONTO PER BRT",
      coloreRiquadro: "dark-red",
      coloreScritta: "white",
      ordiniTrasmessi: [],
    },
    {
      nomeRiquadro: "GLS",
      nomeStato: "PRONTO PER GLS",
      coloreRiquadro: "dark-blue",
      coloreScritta: "white",
      ordiniTrasmessi: [],
    },
    {
      nomeRiquadro: "DHL",
      nomeStato: "PRONTO PER DHL",
      coloreRiquadro: "gold",
      coloreScritta: "black",
      ordiniTrasmessi: [],
    },
    {
      nomeRiquadro: "UPS",
      nomeStato: "PRONTO PER UPS",
      coloreRiquadro: "dark-pink",
      coloreScritta: "white",
      ordiniTrasmessi: [],
    },
    {
      nomeRiquadro: "MANCA ETICHETTA",
      nomeStato: "MANCA ETICHETTA",
      coloreRiquadro: "light-red",
      coloreScritta: "black",
      ordiniTrasmessi: [],
    },
    {
      nomeRiquadro: "MAG ASSENTE",
      nomeStato: "MAGAZZINO ASSENTE",
      coloreRiquadro: "mid-gray",
      coloreScritta: "white",
      ordiniTrasmessi: [],
    },
    {
      nomeRiquadro: "ALTRA ATTESA",
      nomeStato: "ALTRA ATTESA",
      coloreRiquadro: "light-green",
      coloreScritta: "black",
      ordiniTrasmessi: [],
    },
    {
      nomeRiquadro: "RESO CONFORME",
      nomeStato: "RESO CONFORME",
      coloreRiquadro: "dark-green",
      coloreScritta: "white",
      ordiniTrasmessi: [],
    },
  ]);

  const [input, setInput] = useState("");
  const [statoSelezionato, setStatoSelezionato] = useState("PRONTO PER BRT");
  const [arrayOrdiniSparatiMisti, setArrayOrdiniSparatiMisti] = useState([]);
  const [ordiniDaInviare, setOrdiniDaInviare] = useState([]);
  //const [risultatoInvio, setRisultatoInvio] = useState("");

  const suonoConferma = new Audio(beep);
  const suonoErrore = new Audio(errorSound);

  const handleInput = async function (evt) {
    const value = evt.target.value;

    try {
      setInput(value);
    } catch (err) {
      console.log("Errore nel cambio dello stato input: " + err);
      throw err;
    }
  };

  const cambiaStato = function (statoRiquadro) {
    setStatoSelezionato(statoRiquadro);
  };

  const barcodeToOrder = function (barcode) {
    return parseInt(barcode.slice(-6));
  };

  const handleKeyDown = async function (event) {
    //console.log(event.key);

    if (event.key === "Enter") {
      event.preventDefault();
      // GLI ALERT DEVONO BLOCCARE L'INSERIMENTO IN DB O NO?
      try {
        const ordineDaTrasmettere = barcodeToOrder(input);
        try {
          //console.log("invio il codice al server")
          const data = {
            ordine: ordineDaTrasmettere,
            stato: statoSelezionato,
            mag: "Prato Nevoso",
          };

          let tempOrdiniDaInviare = [...ordiniDaInviare];
          let indexOrdinePresente = tempOrdiniDaInviare.findIndex(
            (ord) => ord.ordine === ordineDaTrasmettere
          );

          //console.log("indexOrdinePresente", indexOrdinePresente);

          if (indexOrdinePresente !== -1) {
            //console.log("ordDaIndex per ordine "+data.ordine, ordiniDaInviare[indexOrdinePresente]);
            console.log(ordineDaTrasmettere + " c'è già");
            tempOrdiniDaInviare[indexOrdinePresente].stato = data.stato;
          } else {
            console.log(ordineDaTrasmettere + " non c'è ancora");
            tempOrdiniDaInviare = [...tempOrdiniDaInviare, data];
          }

          setOrdiniDaInviare(tempOrdiniDaInviare);
          console.log("ordiniDaInviare", ordiniDaInviare);
        } catch (err) {
          console.log(
            "Errore nell'aggiunta dell'ordine all'array degli stati da inviare': " +
              err
          );
          throw err;
        }
        try {
          console.log("provo ad aggiungere l'ordine all'array del corriere");
          const statiTemp = stati.map((stato) => {
            //console.log("nomeStato: ",stato.nomeStato,"statoSelezionato: ",statoSelezionato);
            if (stato.nomeStato === statoSelezionato) {
              const nuovaArr = Array.from(stato.ordiniTrasmessi);
              nuovaArr.push(ordineDaTrasmettere);
              return {
                ...stato,
                ordiniTrasmessi: nuovaArr,
              };
            } else {
              return {
                ...stato,
                ordiniTrasmessi: stato.ordiniTrasmessi.filter(function (
                  value,
                  index,
                  arr
                ) {
                  return value !== ordineDaTrasmettere;
                }),
              };
            }
          });
          console.log(statiTemp);
          setStati(statiTemp);
        } catch (err) {
          console.log(
            "Errore nell'aggiunta dell'ordine all'array del corriere: " + err
          );
          throw err;
        }
        try {
          setArrayOrdiniSparatiMisti([
            ...arrayOrdiniSparatiMisti,
            ordineDaTrasmettere,
          ]);
        } catch (err) {
          console.log(
            "Errore nell'aggiunta dell'ordine all'array mista: " + err
          );
          throw err;
        }
        // REQUISITI PER FARE IL SUONO DA AGGIORNARE
        if (
          parseInt(ordineDaTrasmettere) > 68000 &&
          parseInt(ordineDaTrasmettere) < 80000
        ) {
          suonoConferma.play();
        } else {
          suonoErrore.play();
        }
        setInput("");
      } catch (err) {
        console.log("Errore nella gestione del tasto invio: " + err);
        throw err;
      }
    }
  };

  const inviaOrdiniMassivi = async function () {
    try {
      const dataToSend = JSON.stringify({
        dati: ordiniDaInviare,
      });
      let request = new XMLHttpRequest();
      request.open(
        "PATCH",
        apiUrl + "/logistica/sparaOrdini/massChangeOrdersState",
        true
      );
      request.setRequestHeader("Content-Type", "application/json");
      request.send(dataToSend);
      /* setRisultatoInvio(request.response);
            console.log("res",request.response); */
    } catch (err) {
      console.log("Ho inviato gli ordini al server e fatto merda: " + err);
      throw err;
    }
  };

  const countUnique = function (iterable) {
    return new Set(iterable).size;
  };

  return (
    <div className="areaComposizione fr">
      <div className="areaComposizione colonnaTuttaPagina sfondoBiancoTema br4 br--bottom shadow-4 pa2">
        <div className="center tc">
          <h2>MODALITÀ OFFLINE</h2>
          <h3>Assicurati che il cursore lampeggi e spara il barcode</h3>
          <input
            autoFocus
            type="text"
            id="input"
            name="input"
            value={input}
            autoComplete="off"
            onChange={handleInput}
            className={inputClassesConTasto}
            onKeyDown={handleKeyDown}
          />
          {/* <button onClick={(e)=>{}} className={classiTastoSblocco}>INVIA</button> */}
        </div>
        <h3 className="center tc">
          {"All'ordine sarà associato lo stato selezionato: " +
            statoSelezionato}
        </h3>
        <div className="center tc">
          <button
            className={buttonClassesGreen + " mb3"}
            onClick={inviaOrdiniMassivi}
          >
            INVIA TUTTI GLI ORDINI IN CACHE
          </button>
          {/* <p>{risultatoInvio && risultatoInvio}</p> */}
        </div>
        <div className="flex flex-wrap justify-center">
          {stati.map((stato) => {
            const count = {};
            if (stato.ordiniTrasmessi) {
              stato.ordiniTrasmessi.forEach((element) => {
                count[element] = (count[element] || 0) + 1;
              });
            }
            const newArr = Object.entries(count);
            const arrDuplicati = newArr.filter(
              (pair) => pair[1] && pair[1] !== 1
            );
            return (
              <RiquadroStatoBeta
                key={stato.nomeRiquadro}
                ordiniInArray={stato.ordiniTrasmessi.length}
                arrDuplicati={arrDuplicati}
                nomeRiquadro={stato.nomeRiquadro}
                nomeStato={stato.nomeStato}
                coloreRiquadro={stato.coloreRiquadro}
                coloreScritta={stato.coloreScritta}
                ordiniTrasmessi={stato.ordiniTrasmessi}
                statoSelezionato={statoSelezionato}
                cambiaStato={cambiaStato}
              />
            );
          })}
        </div>
        <div className="ultimiOrdiniTrasmessiMobile">
          <StatiTrasmessiTutti array={arrayOrdiniSparatiMisti} />
        </div>
      </div>
    </div>
  );
}

export default AreaLogisticaOffline;
